import React, { useState } from 'react';
import VideoRoom from './VideoRoom';
import ChatRoom from './ChatRoom';

interface VideoChatProps {
  token: string;
  roomName: string;
  onEndCall: () => void;
}

const VideoChat: React.FC<VideoChatProps> = ({ token, roomName, onEndCall }) => {
  const [isChatOpen, setIsChatOpen] = useState(false);

  return (
    <div className="flex h-screen">
      <div className={`transition-all duration-300 ${isChatOpen ? 'w-3/4' : 'w-full'}`}>
        <VideoRoom
          token={token}
          roomName={roomName}
          handleLogout={onEndCall}
        />
      </div>
      
      {isChatOpen && (
        <div className="w-1/4 border-l border-gray-200">
          <ChatRoom token={token} roomName={roomName} />
        </div>
      )}

      <button
        onClick={() => setIsChatOpen(!isChatOpen)}
        className="fixed bottom-4 right-4 p-2 bg-primary text-white rounded-full shadow-lg"
      >
        {isChatOpen ? 'Hide Chat' : 'Show Chat'}
      </button>
    </div>
  );
};

export default VideoChat;
